import { useEffect, useState } from "react";
import {
  SupplierGetIdentityWarehouseUser,
  UsersFilter,
  SupplierSetIdentityWarehouseUser,
} from "../../Api/Services";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

function WarehouseTypeIdentity() {
  const [isLoading, setLoading] = useState(true);
  const [Users, setUsers] = useState([]);
  const [AccesUser, setAccesUser] = useState([]);

  const navigate = useNavigate();

  let { id } = useParams();
  const start = async () => {
    try {
      if (id) {
        const SupplierGetIdentityWarehouseUserData = await SupplierGetIdentityWarehouseUser(
          id
        );
        if (
          SupplierGetIdentityWarehouseUserData.status &&
          SupplierGetIdentityWarehouseUserData.status === 200
        ) {
          var elemet = [];
          SupplierGetIdentityWarehouseUserData.data.data.forEach((element) => {
            elemet.push(element.id);
          });
          setAccesUser(elemet);
        }

        const UsersFilterData = await UsersFilter({});
        if (UsersFilterData.status && UsersFilterData.status === 200) {
          setUsers(UsersFilterData.data.data.data);
        }
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    start();
  }, []);

  const AddUpdate = async () => {
    try {
      const data = {
        usersId: AccesUser,
        WarehouseTypeId: id,
      };
      const SupplierSetIdentityWarehouseUserData = await SupplierSetIdentityWarehouseUser(
        data
      );
      if (
        SupplierSetIdentityWarehouseUserData.status &&
        SupplierSetIdentityWarehouseUserData.status === 200
      ) {
        toast.success("بروزرسانی با موفقیت انجام شد");
        navigate("/Panel/Suppliers/Warehouse/Type");
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleChangeInputCheckBox = async (e) => {
    var idAcees = e.target.id;
    let copy = [...AccesUser];
    let check = copy.find((e) => e == idAcees);
    if (check) {
      copy = copy.filter((item) => item != e.target.id);
    } else {
      copy.push(e.target.id);
    }
    setAccesUser(copy);
  };

  return (
    <div>
      {isLoading && (
        <div className="d-flex justify-content-center align-items-center">
          <div className="lds-facebook">
            <div />
            <div />
            <div />
          </div>
        </div>
      )}
      <div className={isLoading ? "startLoading" : "stateLoading"}>
        <div className="w-100 d-flex justify-content-between align-items-start p-5">
          <div className="d-flex justify-content-start align-items-center flex-column element w-100 p-5">
            <div className="d-flex justify-content-start align-items-center flex-wrap  ">
              <table className="table">
                <thead className="sticky-header">
                  <tr className="trTable">
                    <th>دسترسی</th>
                    <th>نام</th>
                    <th>نام خانوادگی</th>
                    <th>شماره موبایل</th>
                  </tr>
                </thead>
                <tbody className="identitystyle">
                  {Users &&
                    Users.map((item) => (
                      <tr>
                        <td>
                          <input
                            id={item.id}
                            type="checkbox"
                            onChange={handleChangeInputCheckBox}
                            checked={AccesUser.find((e) => e == item.id)}
                          />
                        </td>
                        <td>{item.firstName}</td>
                        <td>{item.lastName}</td>
                        <td>{item.userName}</td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
            <div className="d-flex justify-content-start align-items-center w-100 m-5">
              <button onClick={AddUpdate} className="butAU">
                اعمال
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WarehouseTypeIdentity;
